import React, { useState } from 'react';
import './Leaderboard.css'; // Ensure the CSS file is correctly linked

const Leaderboard = () => {
    const [activeTab, setActiveTab] = useState('1v1');

    const leaderboardData = {
        '1v1': [
            { rank: 1, name: 'PlayerOne', score: 1500 },
            { rank: 2, name: 'PlayerTwo', score: 1400 },
            { rank: 3, name: 'PlayerThree', score: 1300 },
            { rank: 4, name: 'PlayerFour', score: 1200 },
            { rank: 5, name: 'PlayerFive', score: 1100 },
            { rank: 6, name: 'PlayerSix', score: 1000 },
            { rank: 7, name: 'PlayerSeven', score: 900 },
            { rank: 8, name: 'PlayerEight', score: 800 },
            { rank: 9, name: 'PlayerNine', score: 700 },
            { rank: 10, name: 'PlayerTen', score: 600 },
        ],
        '2v2': [
            { rank: 1, name: 'PlayerOne', score: 1600 },
            { rank: 2, name: 'PlayerTwo', score: 1500 },
            { rank: 3, name: 'PlayerThree', score: 1400 },
            { rank: 4, name: 'PlayerFour', score: 1300 },
            { rank: 5, name: 'PlayerFive', score: 1200 },
            { rank: 6, name: 'PlayerSix', score: 1100 },
            { rank: 7, name: 'PlayerSeven', score: 1000 },
            { rank: 8, name: 'PlayerEight', score: 900 },
            { rank: 9, name: 'PlayerNine', score: 800 },
            { rank: 10, name: 'PlayerTen', score: 700 },
        ],
        '3v3': [
            { rank: 1, name: 'PlayerOne', score: 1700 },
            { rank: 2, name: 'PlayerTwo', score: 1600 },
            { rank: 3, name: 'PlayerThree', score: 1500 },
            { rank: 4, name: 'PlayerFour', score: 1400 },
            { rank: 5, name: 'PlayerFive', score: 1300 },
            { rank: 6, name: 'PlayerSix', score: 1200 },
            { rank: 7, name: 'PlayerSeven', score: 1100 },
            { rank: 8, name: 'PlayerEight', score: 1000 },
            { rank: 9, name: 'PlayerNine', score: 900 },
            { rank: 10, name: 'PlayerTen', score: 800 },
        ],
    };

    const renderLeaderboard = (mode) => {
        return (
            <div className="leaderboard-grid">
                {leaderboardData[mode].map(player => (
                    <div key={player.rank} className="leaderboard-item">
                        <div className={`leaderboard-rank rank-${player.rank}`}>
                            {player.rank}
                        </div>
                        <div className="leaderboard-name">
                            {player.name}
                        </div>
                        <div className="leaderboard-score">
                            {player.score}
                        </div>
                    </div>
                ))}
            </div>
        );
    };

    return (
        <section className="leaderboard">
            <h2>Leaderboard</h2>
            <div className="tabs">
                <button className={activeTab === '1v1' ? 'active' : ''} onClick={() => setActiveTab('1v1')}>1v1</button>
                <button className={activeTab === '2v2' ? 'active' : ''} onClick={() => setActiveTab('2v2')}>2v2</button>
                <button className={activeTab === '3v3' ? 'active' : ''} onClick={() => setActiveTab('3v3')}>3v3</button>
            </div>
            {renderLeaderboard(activeTab)}
        </section>
    );
};

export default Leaderboard;
